import { render, staticRenderFns } from "./ButtonsPicker.vue?vue&type=template&id=32189b65&scoped=true"
import script from "./ButtonsPicker.vue?vue&type=script&lang=js"
export * from "./ButtonsPicker.vue?vue&type=script&lang=js"
import style0 from "./ButtonsPicker.vue?vue&type=style&index=0&id=32189b65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32189b65",
  null
  
)

export default component.exports